// Lightweight IndexedDB wrapper for Cropasaurus "nests" (saved projects).
// Stores nest metadata + image blobs together so projects can fully restore.

const DB_NAME = 'cropasaurus-rex';
const DB_VERSION = 1;
const STORE_NESTS = 'nests';

function openDb() {
  return new Promise((resolve, reject) => {
    const req = indexedDB.open(DB_NAME, DB_VERSION);
    req.onupgradeneeded = () => {
      const db = req.result;
      if (!db.objectStoreNames.contains(STORE_NESTS)) {
        db.createObjectStore(STORE_NESTS, { keyPath: 'id' });
      }
    };
    req.onsuccess = () => resolve(req.result);
    req.onerror = () => reject(req.error);
  });
}

async function tx(mode, fn) {
  const db = await openDb();
  return new Promise((resolve, reject) => {
    const t = db.transaction(STORE_NESTS, mode);
    const store = t.objectStore(STORE_NESTS);
    let out;
    t.oncomplete = () => resolve(out);
    t.onerror = () => reject(t.error);
    t.onabort = () => reject(t.error);
    out = fn(store);
  });
}

export async function listNests() {
  return tx('readonly', (store) => new Promise((resolve, reject) => {
    const r = store.getAll();
    r.onsuccess = () => {
      const items = (r.result || []).map(n => ({
        id: n.id, name: n.name, updatedAt: n.updatedAt,
        sheetCount: (n.sheets || []).length,
        boxCount: (n.sheets || []).reduce((a, s) => a + (s.boxes?.length || 0), 0),
      }));
      items.sort((a, b) => b.updatedAt - a.updatedAt);
      resolve(items);
    };
    r.onerror = () => reject(r.error);
  }));
}

export async function saveNest(nest) {
  // nest = { id, name, sheets:[{name, blob, boxes:[]}], settings, customNames, previewOrder }
  const record = { ...nest, updatedAt: Date.now() };
  return tx('readwrite', (store) => store.put(record));
}

export async function loadNest(id) {
  return tx('readonly', (store) => new Promise((resolve, reject) => {
    const r = store.get(id);
    r.onsuccess = () => resolve(r.result || null);
    r.onerror = () => reject(r.error);
  }));
}

export async function deleteNest(id) {
  return tx('readwrite', (store) => store.delete(id));
}

export function newNestId() {
  return 'n_' + Date.now().toString(36) + '_' + Math.random().toString(36).slice(2, 7);
}
